import React from 'react'
import { ExternalToast, toast } from 'sonner'
import { LucideIcon, LucideIconName } from 'utils/lucideIcon'

type MessageType = 'success' | 'error' | 'warning' | 'info'

const icons: Record<MessageType, LucideIconName> = {
    success: 'Check',
    warning: 'CircleAlert',
    error: 'TriangleAlert',
    info: 'Info',
}

export const showMessage = (message: string, type: MessageType, options?: ExternalToast) => {
    toast[type](message, {
        duration: 10000,
        icon: <LucideIcon iconName={icons[type]} size={16} />,
        ...options,
    })
}

export const showSuccessMessage = (message: string, id?: string | number, options?: ExternalToast) =>
    showMessage(message, 'success', { id, ...options })

export const showErrorMessage = (message: string, id?: string | number, options?: ExternalToast) =>
    showMessage(message, 'error', { id, ...options })

export const showWarningMessage = (message: string, id?: string | number, options?: ExternalToast) =>
    showMessage(message, 'warning', { id, ...options })

export const showInfoMessage = (message: string, id?: string | number, options?: ExternalToast) =>
    showMessage(message, 'info', { id, ...options })

export const hideMessage = (id: string | number) => toast.dismiss(id)

export const hideAllMessages = () => toast.dismiss()
